import infocircle from "../../assets/images/info-circle.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function CurrencyWrapper({ content, sellContent }) {
  const [paymentDropdown, setPaymentDropdown] = useState(false);
  return (
    <>
      <div className="currencyWrapper bg-black text-white md:w-90 w-full whitespace-nowrap flex px-2 justify-between items-center py-3 md:p-5 rounded-md self-center m-auto	">
        <span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99953 1.66679C5.4162 1.66679 1.6662 5.41679 1.6662 10.0001M18.3329 10.0001C18.3329 14.5835 14.5829 18.3335 9.99953 18.3335"
              stroke="#C4FE48"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <g opacity="0.4">
              <path
                d="M6.66638 9.99995H13.333"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.0002 6.66674V13.3334"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </span>
        <span className="md:text-lg ml-1 flex">
          <span className="w-[44px] md:w-fit hide-scrollbar  overflow-hidden">
            {sellContent.amount && !isNaN(sellContent.amount)
              ? parseFloat(sellContent.amount) % 1 === 0
                ? parseInt(sellContent.amount, 10)
                : parseFloat(sellContent.amount).toFixed(5)
              : "0"}
          </span>{" "}
          {sellContent.coinName} =
          <div className="w-[44px] flex md:w-fit hide-scrollbar overflow-scroll ">
            {content.amount && !isNaN(content.amount)
              ? parseFloat(content.amount) % 1 === 0
                ? parseInt(content.amount, 10)
                : parseFloat(content.amount).toFixed(5)
              : "0"}
          </div>{" "}
          {content.coinName}{" "}
        </span>
        <span className=" text-xs p-1 text-gray-400">(-$15442.8)</span>
        <span className="md:text-lg p-1 float-right">
          <select
            id="currency"
            class="bg-gray-50 bg-transparent text-white-900 border-none "
          >
            <option selected>-$6.73</option>
            <option
              className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
              value="BTH"
            >
              -$12.73
            </option>
            <option value="BTH">-$32.73</option>
            <option value="BTH">-$53.73</option>
            <option value="BTH">-$21.73</option>
          </select>
          {/* <span className='cursor-pointer' onClick={() => setPaymentDropdown(!paymentDropdown)} ><FontAwesomeIcon icon={faChevronDown} />
            </span> */}
          {paymentDropdown && (
            <div className="mt-2 relative h-0 w-0  bg-black border border-gray-700 rounded shadow-lg">
              <div className="bg-black -ml-8 w-[100px]">
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
                >
                  -$16.73
                </a>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
                >
                  -$26.73
                </a>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
                >
                  -$36.73
                </a>
              </div>
            </div>
          )}
        </span>
      </div>
    </>
  );
}
